import { forwardRef } from "react";
import {
  Dialog,
  AppBar,
  Toolbar,
  Container,
  Box,
  Slide,
} from "@mui/material";
import { BreadcrumbsNavbar } from "components";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

export function BasePageDialog({ 
  open, 
  onClose, 
  title, 
  actions, 
  children,
  maxWidth = "lg" 
}) {
  return (
    <Dialog
      fullScreen
      open={open}
      onClose={onClose}
      TransitionComponent={Transition}
      sx={{
        "& .MuiDialog-paper": {
          marginTop: { xs: "56px", sm: "64px" },
          height: { xs: "calc(100% - 56px)", sm: "calc(100% - 64px)" },
          bgcolor: "background.default",
        },
      }}
    >
      <AppBar position="sticky" elevation={0}>
        <Container maxWidth={maxWidth}>
          <Toolbar disableGutters>
            <Box sx={{ flex: 1, minWidth: 0 }}>
              <BreadcrumbsNavbar onBack={onClose} title={title} />
            </Box>

            <Box sx={{ display: "flex", gap: 1, mr: 1 }}>
              {actions}
            </Box>
          </Toolbar>
        </Container>
      </AppBar>

      <Container
        maxWidth={maxWidth}
        sx={{
          py: 3,
          px: { xs: 2, sm: 3 },
        }}
      >
        {children}
      </Container>
    </Dialog>
  );
}